<template>
  <RequestProposalNoTurnGrid/>
</template>

<script>
import RequestProposalNoTurnGrid from './RequestProposalNoTurnGrid'
export default {
  components: {
    RequestProposalNoTurnGrid
  },
  data () {
    return {

    }
  },
  created () {
    this.$store.commit('updateTitle', 'Reporte de OCs sin Turno')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/OCsinTurnos.vue